import { useState } from 'react';
import { Calendar, ChevronDown, ChevronUp } from 'lucide-react';
import TranslatedContent from '../TranslatedContent';
import { useLanguage } from '../../context/LanguageContext';

// Single parish-announcement card with collapse/expand for long content.
const AnnouncementCard = ({ announcement }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useLanguage();

  // Decide collapse based on visible text length, not raw HTML
  const contentText = announcement.content?.replace(/<[^>]*>/g, '') || '';
  const needsExpansion = contentText.length > 150;

  // Only show event_date if it exists and parses cleanly
  const eventDate = announcement.event_date ? new Date(announcement.event_date) : null;
  const formattedEventDate = eventDate && !Number.isNaN(eventDate.getTime())
    ? eventDate.toLocaleDateString('sv-SE', { weekday: 'short', day: 'numeric', month: 'short' })
    : null;

  return (
    <div className="p-4 hover:bg-gray-50 transition-colors">
      {announcement.featured_image && (
        <img
          src={announcement.featured_image}
          alt=""
          className="w-full h-32 object-cover rounded-lg mb-3"
        />
      )}
      {formattedEventDate && (
        <p className="text-xs text-yellow-700 font-medium mb-1 flex items-center gap-1">
          <Calendar className="w-3 h-3" />
          {formattedEventDate}
        </p>
      )}
      <TranslatedContent
        content={{ sv: announcement.title }}
        as="h4"
        className="font-semibold text-gray-900 mb-2"
      />
      <TranslatedContent
        content={{ sv: announcement.content }}
        as="div"
        className={`text-sm text-gray-600 ${!isExpanded && needsExpansion ? 'line-clamp-3' : ''}`}
        html={true}
      />
      {needsExpansion && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-2 text-sm font-medium text-yellow-600 hover:text-yellow-700 flex items-center gap-1 transition-colors"
        >
          {isExpanded ? (
            <>
              {t('showLess') || 'Visa mindre'}
              <ChevronUp className="w-4 h-4" />
            </>
          ) : (
            <>
              {t('readMore') || 'Läs mer'}
              <ChevronDown className="w-4 h-4" />
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default AnnouncementCard;
